import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateFirestopListAsDeleted = async (
  projectId,
  firestopListId
) => {
  const apiPath = `firestop-documentation/project/${projectId}/firestop-list/${firestopListId}/update-as-deleted`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
  });
  const response = await axios(signedRequest);

  return response.data;
};
